import { Button, Form, Modal, Stack } from "react-bootstrap"
import InputField from "../common/InputField"
import { useState } from "react"
import { vehicleLengthOptions } from "../../constants/Constants"
import { Loader } from "../common/Loader"
import { ReactSelect } from "../common/ReactSelect"
import { UploadImage } from "../common/UploadImage"
import { BiImageAdd } from "react-icons/bi"
import { addVehicle } from "../../services/Networkcall"
import { errorAlert, successAlert } from "../common/Alert"

export const AddVehicle = ({ show, closeModal ,setRefetch}) => {
    const [fdata, setFdata] = useState({ name: "", licensePlate: "", state: "", vehicleType: "", image: null });
    const [error, setError] = useState({ name: "", licensePlate: "", state: "", vehicleType: "", image: '' });
    const [loading, setLoading] = useState(false);

    const options = vehicleLengthOptions.map((e) => ({
        value: e.value,
        label: (
            <Stack direction="horizontal" className="justify-content-between w-100 text-start" gap={5}  >
                <span className="fw-bold f-sm-8 ">{e.name.v_type}</span>
                <span className="text-start text-sm-end text-nowrap f-sm-8 w-25">{e.name.v_length}</span>
            </Stack>
        ),
        isDisabled: e.isDisabled || false,
    }));

    const submitHandler = async (e) => {
        e.preventDefault();

        let isValid = true;

        const newError = { name: "", licensePlate: "", state: "", vehicleType: "" };

        if (!fdata.name || !fdata.name.trim()) { isValid = false; newError.name = "Vehicle name is required"; }
        else if (fdata.name.trim().length < 2) { isValid = false; newError.name = "Vehicle name must be at least 2 characters"; }

        if (!fdata.licensePlate || !fdata.licensePlate.trim()) { isValid = false; newError.licensePlate = "License plate is required"; }
        else if (!/^[A-Za-z0-9- ]+$/.test(fdata.licensePlate)) { isValid = false; newError.licensePlate = "Invalid license plate format"; }

        if (!fdata.state || !fdata.state.trim()) { isValid = false; newError.state = "State is required"; }

        if (!fdata.vehicleType) { isValid = false; newError.vehicleType = "Vehicle type is required"; }

        setError(newError);
        if (!isValid) return;

        if (isValid) {
            const payload = {
                "vehicles": [
                    {
                        "licensePlate": fdata.licensePlate,
                        "state": fdata.state,
                        "vehicleName": fdata.name,
                        "length": fdata.vehicleType,
                    }
                ]
            }
            setLoading(true);
            try {
                const res = await addVehicle(payload);
                if (res?.success) {
                    successAlert({ message: res?.message })
                    closeModal();
                    setRefetch(true);
                }
                else {
                    errorAlert({ message: res?.message })
                }
            } catch (err) {
                errorAlert({message: err?.response?.data?.message || err?.message ||  "something went wrong." })
            }
            finally {
                setLoading(false);
            }
        }


    }


    const inputHandler = (e) => {

        if (!e.target) {
            setFdata((prev) => ({ ...prev, vehicleType: e.value }));
            setError((prev) => ({ ...prev, vehicleType: "" }));
            return;
        }
        const { name, value } = e.target;
        setFdata((pre) => ({ ...pre, [name]: value }));
        setError((pre) => ({ ...pre, [name]: "" }));
    }


    return (
        <>
            <Loader show={loading} />
            <Modal show={show} onHide={closeModal} centered  backdrop={'static'}>
                <Modal.Header closeButton><p className="w-100 text-center mb-0 fw-bold">Add Vehicle</p></Modal.Header>
                <Modal.Body>
                    <Form onSubmit={submitHandler}>
                        <Stack direction="vertical" gap={3}>
                            <InputField
                                type={"text"}
                                label={'Vehicle Name'}
                                autoComplete={"off"}
                                value={fdata.name}
                                onChange={inputHandler}
                                name={'name'}
                                placeholder="Enter vehicle name"
                            />

                            <InputField
                                type={"text"}
                                label={'License Plate'}
                                autoComplete={"off"}
                                value={fdata.licensePlate}
                                onChange={inputHandler}
                                name={'licensePlate'}
                                placeholder="Enter License plate"
                            />
                            <InputField
                                type={"text"}
                                label={'State'}
                                autoComplete={"off"}
                                value={fdata.state}
                                onChange={inputHandler}
                                name={'state'}
                                placeholder="Enter state"
                            />
                            <ReactSelect
                                label={'Vehicle Type & Length'}
                                value={options.find(
                                    option =>
                                        option.value ===
                                        fdata.vehicleType
                                )}
                                options={options}
                                name={'vehicleType'}
                                onChange={inputHandler}
                            />
                            <Button className="w-100 rounded login-btn " variant="primary" type="submit">Submit</Button>
                        </Stack>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    )
}